var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuffle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4708 0.31952C16.0448 0.745547 16.0448 1.43627 16.4708 1.8623L17.1566 2.54813H14.8151C13.3733 2.54813 12.0016 3.21499 11.0522 4.37757L2.94266 14.3076C2.37299 15.0052 1.55001 15.4053 0.684927 15.4053H0V17.5481H0.684927C2.12674 17.5481 3.49837 16.8813 4.44781 15.7187L12.5573 5.78865C13.127 5.0911 13.95 4.69099 14.8151 4.69099H17.4991L16.4708 5.71924C16.0448 6.14527 16.0448 6.836 16.4708 7.26202C16.8968 7.68805 17.5876 7.68805 18.0136 7.26202L21.1313 4.14432C21.3265 3.94906 21.3265 3.63248 21.1313 3.43722L18.0136 0.31952C17.5876 -0.106507 16.8968 -0.106507 16.4708 0.31952ZM1.36879 1.54813C2.76049 1.54813 4.08446 2.19407 5.0009 3.32018L7.45312 6.17275L6 7.54813L3.54806 4.687C2.9982 4.01133 2.20381 3.62377 1.36879 3.62377H0.000425339V1.54813H1.36879ZM11.3284 13.7761C12.2449 14.9022 13.5688 15.5481 14.9605 15.5481H17.6419L16.4708 16.7192C16.0448 17.1453 16.0448 17.836 16.4708 18.262C16.8968 18.688 17.5876 18.688 18.0136 18.262L21.1313 15.1443C21.3265 14.9491 21.3265 14.6325 21.1313 14.4372L18.0136 11.3195C17.5876 10.8935 16.8968 10.8935 16.4708 11.3195C16.0448 11.7455 16.0448 12.4363 16.4708 12.8623L17.081 13.4725H14.9605C14.1255 13.4725 13.3311 13.0849 12.7813 12.4093L11 10.0481L9.5 11.5481L11.3284 13.7761Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.8e259f2df0e56ffaab6740a9664e9a85.svg";
export { ForwardRef as ReactComponent };